import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  paymentCheckSuccess: null,
  isLoggedIn: null,
  isOperator: 0,
  accountActive: true,
  bId: null,
};

const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    paymentCheckFailed: state => ({
      ...state,
      paymentCheckSuccess: false,
    }),
    paymentCheckSuccess: state => ({
      ...state,
      paymentCheckSuccess: true,
    }),
    accountDisabled: state => ({
      ...state,
      accountActive: false,
    }),
    accountEnabled: state => ({
      ...state,
      accountActive: true,
    }),
    loggedInSuccess: (state, action) => ({
      ...state,
      isLoggedIn: true,
      isOperator: action.payload,
    }),
    loggedInFailure: state => ({
      ...state,
      isLoggedIn: false,
      isOperator: 0,
    }),
    setBId: (state, action) => ({
      ...state,
      bId: action.payload,
    }),
  },
});

export const {
  paymentCheckFailed,
  paymentCheckSuccess,
  accountDisabled,
  accountEnabled,
  loggedInSuccess,
  loggedInFailure,
  setBId,
} = authorizationSlice.actions;

export default authorizationSlice.reducer;

export const getPaymentCheckSuccess = state => state?.paymentCheckSuccess;

export const getLoggedInStatus = state => state?.isLoggedIn;

export const getAccountActiveStatus = state => state?.accountActive;

export const getIsOperator = state => state?.isOperator;

export const getBId = state => state?.bId;
